export default __webpack_public_path__ + "static/media/discord.495ab24a.svg";